import { render, staticRenderFns } from "./AppStandardSnackbar.vue?vue&type=template&id=618879d4&scoped=true&"
import script from "./AppStandardSnackbar.vue?vue&type=script&lang=js&"
export * from "./AppStandardSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./AppStandardSnackbar.vue?vue&type=style&index=0&id=618879d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618879d4",
  null
  
)

export default component.exports